import React from 'react'
import styles from "./Success.module.scss"

const Success = () => (
    <div className={styles.container}>
        <p className={styles.mainMessage}>
            Thank you for your interest in Mindfire Solutions. In case your profile is found suitable for any open position within the organization, we will get in touch with you.
        </p>
        <p className={styles.message}>
            We hope to have positive discussion with you soon.
        </p>
        <p className={styles.message}>
            In case of any difficulty in submitting your profile or other recruitment related queries, please email to <a href="mailto:hr@mindfiresolutions.com">hr@mindfiresolutions.com</a>
        </p>
    </div>
)

export {Success};